import * as React from "react";
import type { SVGProps } from "react";
const SvgIcMinus = (props: SVGProps<SVGSVGElement>) => <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><mask style={{
    maskType: "alpha"
  }} maskUnits="userSpaceOnUse" x={0} y={0} width={16} height={16}><path fill="currentColor" d="M0 0H16V16H0z" /></mask><g mask="url(#mask0_6202_17089)"><path d="M3.33301 8.5V7.5H12.6663V8.5H3.33301Z" fill="currentColor" /></g></svg>;
export default SvgIcMinus;